(function () {
    'use strict';

    var serviceId = 'otpService';

    angular.module('app.core')
        .factory(serviceId, ['$q', 'user_factory', 'ngDialog', '$timeout', 'auth_factory', otpService]);

    function otpService($q, user_factory, ngDialog, $timeout, auth_factory) {
        var isActive = true;
        var service = {
            openOtpDialog: openOtpDialog,
            callOtp: callOtp,
            purifyOtpError: purifyOtpError,
            otpError: null,
            verifyOtp: verifyOtp,
            dialog: null,
            closeDialog: closeDialog
        };
        return service;


        function closeDialog() {
            if (service.dialog) {
                service.dialog.close();
            }
        }

        function openOtpDialog(otpType, codeExpireDate, verificationToken, verificationType, verificationAddress) {
            var deferred = $q.defer();
            var stopped
            service.dialog = ngDialog.open({
                template: "app/security/phone-otp.modal.html",
                controller: ['$scope', function ($scope) {
                    $scope.otpError = service.otpError;
                    $scope.verificationToken = verificationToken
                    $scope.verificationCode = '';
                    $scope.verificationType = verificationType;
                    $scope.verificationAddress = verificationAddress;

                    var currentDate = new Date();
                    var stop = function () {
                        $timeout.cancel(stopped);
                    };
                    function getTime() {
                        if (!codeExpireDate) {
                            return 300
                        }
                        let expires = moment(codeExpireDate);
                        let created = moment(currentDate);
                        return expires.diff(created, 'seconds');
                    }

                    var time = getTime() > 0 ? getTime() : 0;

                    $scope.timing = function () {
                        var minutes = Math.floor(time / 60);
                        var seconds = time - minutes * 60;
                        return {
                            minutes: minutes,
                            seconds: seconds
                        }
                    }

                    function verificationTimeout() {
                        if (time <= 0) {
                            service.closeDialog();
                            deferred.resolve();
                            stop();
                        }

                    }

                    var countdown = function () {
                        stopped = time > 0 ? $timeout(function () {
                            time--;
                            if (time <= 0)
                                verificationTimeout();
                            countdown();
                        }, 1000) : null;
                    };

                    countdown();
                    $scope.verifyOTP = function (verificationCode, verificationToken) {
                        service.otpError = undefined
                        $scope.otpLoading = true
                        // Broadcast the event
                        var obj = {
                            verificationAddress: verificationAddress,
                            verificationType: verificationType,
                            verificationCode: verificationCode,
                            verificationToken: verificationToken,
                            codeExpireDate: codeExpireDate
                        }
                        service.verifyOtp(otpType, obj).then(function (resp) {
                            $scope.otpLoading = false
                            service.otpError = purifyOtpError(resp);
                            deferred.resolve(resp)
                        }, function (err) {
                            $scope.otpLoading = false
                            service.otpError = purifyOtpError(err);
                            deferred.reject(err)
                        })
                    };
                    $scope.closeDialogWithReject = function () {
                        service.otpError = undefined
                        service.closeDialog();
                        deferred.resolve();
                    };
                }],
                showClose: true,
                closeByEscape: false,
                closeByNavigation: false,
                closeByDocument: false,
                preCloseCallback: function () {
                    $timeout.cancel(stopped)
                },
            });

            return deferred.promise;
        }
        function callOtp(otpType, verificationType, verificationAddress, expireDate, token, ETToken, eimageCaptcha) {
            var deferred = $q.defer();
            if (!isActive && otpType === "profileUpdateAdmin") {
                deferred.resolve({ success: true });
                return deferred.promise;
            }
            if (verificationType === 1) {
                verificationAddress = verificationAddress.replace(/\s+/g, '');
            }
            if (otpType === "profileUpdate" || otpType === "profileUpdateAdmin") {
                service.otpError = undefined;
                var updatePhoneParams = { verificationType: verificationType, verificationAddress: verificationAddress, language: window.langCode(), captchaTokenCustom: window.ecSec() };
                if (ETToken) {
                    updatePhoneParams.ETToken = ETToken;
                }
                if (eimageCaptcha) {
                    updatePhoneParams.EImageCaptchaKey = eimageCaptcha.key;
                    updatePhoneParams.EImageCaptchaValue = eimageCaptcha.value;
                }
                user_factory.update_phone(updatePhoneParams).$promise.then(function (resp) {
                    openOtpDialog(otpType, resp.codeExpireDate, resp.verificationToken, verificationType, verificationAddress).then(function (resp) {
                        deferred.resolve(resp);
                    }, function (err) {
                        deferred.reject(err);
                    })
                }, function (err) {
                    deferred.reject(err);
                })
            } else if (otpType === "loginAndRegister") {
                service.otpError = undefined;
                var sendcodeParams = { verificationType: verificationType, verificationAddress: verificationAddress, language: window.langCode(), captchaTokenCustom: window.ecSec() };
                if (ETToken) {
                    sendcodeParams.ETToken = ETToken;
                }
                if (eimageCaptcha) {
                    sendcodeParams.EImageCaptchaKey = eimageCaptcha.key;
                    sendcodeParams.EImageCaptchaValue = eimageCaptcha.value;
                }
                auth_factory.sendcode(sendcodeParams).$promise.then(function (resp) {
                    openOtpDialog(otpType, resp.codeExpireDate, resp.verificationToken, verificationType, verificationAddress).then(function (resp) {
                        if (resp)
                            service.closeDialog();
                        deferred.resolve(resp);
                    }, function (err) {
                        service.closeDialog();
                        deferred.reject(err);
                    })
                }, function (err) {
                    deferred.reject(err);
                });
            } else if (otpType === "retry") {
                openOtpDialog(otpType, expireDate, token, verificationType, verificationAddress).then(function (resp) {
                    if (resp)
                        service.closeDialog();
                    deferred.resolve(resp);
                }, function (err) {
                    service.closeDialog();
                    deferred.reject(err);
                })
            }
            return deferred.promise;
        }
        function verifyOtp(otpType, obj) {
            var deferred = $q.defer();
            if (otpType === "profileUpdate" || otpType === "profileUpdateAdmin") {
                user_factory.verify_phone({ verificationToken: obj.verificationToken, code: obj.verificationCode.toString() }).$promise.then(function (resp) {
                    resp.validateRequest = {
                        verificationAddress: obj.verificationAddress,
                        verificationType: obj.verificationType,
                        codeExpireDate: obj.codeExpireDate,
                        verificationToken: obj.verificationToken,
                        code: obj.verificationCode.toString()
                    }
                    if (resp.success == false) {
                        deferred.reject(resp);
                    } else {
                        deferred.resolve(resp);
                    }
                }, function (err) {
                    err.validateRequest = {
                        verificationAddress: obj.verificationAddress,
                        verificationToken: obj.verificationToken,
                        verificationType: obj.verificationType,
                        codeExpireDate: obj.codeExpireDate,
                        code: obj.verificationCode.toString()
                    }

                    deferred.reject(err);
                })
            } else {
                auth_factory.checkuserandverifycode({ verificationToken: obj.verificationToken, code: obj.verificationCode.toString(), captchaTokenCustom: window.ecSec() }).$promise.then(function (resp) {
                    resp.validateRequest = {
                        verificationAddress: obj.verificationAddress,
                        verificationType: obj.verificationType,
                        codeExpireDate: obj.codeExpireDate,
                        verificationToken: obj.verificationToken,
                        code: obj.verificationCode.toString()
                    }
                    if (resp.success == false) {
                        deferred.reject(resp);
                    } else {
                        deferred.resolve(resp);
                    }
                }, function (err) {
                    err.validateRequest = {
                        verificationAddress: obj.verificationAddress,
                        verificationToken: obj.verificationToken,
                        verificationType: obj.verificationType,
                        codeExpireDate: obj.codeExpireDate,
                        code: obj.verificationCode.toString()
                    }
                    deferred.reject(err);
                })
            }
            return deferred.promise;
        }
        function purifyOtpError(err) {
            if (err.data) {
                if (err.data.title) {
                    if (err.data.title.indexOf("Request is exceed") > -1) {
                        return "otp_err_lmt_exceed";
                    } else if (err.data.title.indexOf("code entered is incorrect") > -1) {
                        return "otp_err_invalid_code";
                    } else if (err.data.title.indexOf("One or more validation") > -1) {
                        return "otp_err_validation";
                    } else if (err.data.title.indexOf("token has expired") > -1) {
                        return "otp_err_expired";
                    } else if (err.data.detail) {
                        if (err.data.detail.indexOf("Invalid Em") > -1) {
                            return "otp_err_invalid_email";
                        } else {
                            return "otp_generic_err";
                        }
                    } else {
                        return "otp_generic_err";
                    }
                } else {
                    if (err.data.indexOf("Request is exceed") > -1) {
                        return "otp_err_lmt_exceed";
                    } else if (err.data.indexOf("code entered is incorrect") > -1) {
                        return "otp_err_invalid_code";
                    } else if (err.data.indexOf("token has expired") > -1) {
                        return "otp_err_expired";
                    } else if (err.data.indexOf("user_cancel") > -1) {
                        return "otp_err_user_cancelled";
                    } else {
                        return "otp_generic_err";
                    }
                }
            } else if (err.failureReason) {
                if (err.failureReason.indexOf("Request is exceed") > -1) {
                    return "otp_err_lmt_exceed";
                } else if (err.failureReason.indexOf("code entered is incorrect") > -1) {
                    return "otp_err_invalid_code";
                } else if (err.failureReason.indexOf("verification code") > -1) {
                    return "otp_err_invalid_code";
                } else if (err.failureReason.indexOf("token has expired") > -1) {
                    return "otp_err_expired";
                } else {
                    return "otp_generic_err";
                }
            } else {
                return "otp_generic_err";
            }
        }
    }
})();
